module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    ref: "cards",
    staticClass: "card-list"
  }, [_c('li', {
    staticClass: "card"
  }, [_c('h2', [_vm._v(_vm._s(_vm.cardNumber(_vm.cards)) + " cards")])]), _vm._v(" "), _vm._l((_vm.filteredCards), function(card) {
    return _c('card', {
      key: card.key,
      attrs: {
        "card": card,
        "user": _vm.user
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-52d436f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/Index.vue
// module id = 199
// module chunks = 1